module.exports = __webpack_public_path__ + "images/Token-Overlay-d4bdfe20a0726e5b5c81b25cfe44263e.jpg";